// import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import RequireRoles from './components/RequireRoles';
import DashboardLayout from './components/layout/DashboardLayout';
import { FULL_ACCESS_ROLES } from './utils/auth';
import Login from './pages/Login';
import MachineList from './pages/MachineList';
import DeviceConfig from './pages/DeviceConfig';
import DeviceStatus from './pages/DeviceStatus';
import DeviceLogs from './pages/DeviceLogs';
import MachineMgr from './pages/MachineMgr';
import MachineUserCloudSyncLog from './pages/MachineUserCloudSyncLog';
import Companies from './pages/Companies';
import AppUpdateChannelMgr from './pages/AppUpdateChannelMgr';
import AppUpdateDeviceIdMgr from './pages/AppUpdateDeviceIdMgr';
import AppVersionStatistics from './pages/AppVersionStatistics';
import AppUpdateOverview from './pages/AppUpdateOverview';
import AppUpdateApps from './pages/AppUpdateApps';
import HubOtaManagement from './pages/HubOtaManagement';
import ImuOtaManagement from './pages/ImuOtaManagement';
import GnssOtaManagement from './pages/GnssOtaManagement';
import HubErrorDetectConfig from './pages/HubErrorDetectConfig';
import Incidents from './pages/Incidents';
import MachineNotes from './pages/MachineNotes';
import ImuInstallation from './pages/ImuInstallation';
import UserManagement from './pages/UserManagement';
import ImuProduction from './pages/ImuProduction';
import Analytics from './pages/Analytics';
import Account from './pages/Account';

// Wrap a page that is hidden from the company-scoped partner role
const fullAccessOnly = page => <RequireRoles roles={FULL_ACCESS_ROLES}>{page}</RequireRoles>;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<MachineList />} />
          <Route path="device/:serialNumber/config" element={<DeviceConfig />} />
          <Route path="device/:serialNumber/status" element={<DeviceStatus />} />
          <Route path="device/:serialNumber/logs" element={<DeviceLogs />} />
          <Route path="device/:serialNumber/error-detect" element={<HubErrorDetectConfig />} />
          <Route path="machines" element={fullAccessOnly(<MachineMgr />)} />
          <Route path="machines/cloud-sync" element={fullAccessOnly(<MachineUserCloudSyncLog />)} />
          <Route
            path="machines/sync-log"
            element={<Navigate to="/machines/cloud-sync" replace />}
          />
          <Route path="machines/companies" element={fullAccessOnly(<Companies />)} />
          <Route path="machine/:machineId/incidents" element={<Incidents />} />
          <Route path="machine/:machineId/notes" element={<MachineNotes />} />
          <Route path="machine/:machineId/imu-installation" element={<ImuInstallation />} />
          <Route path="app-update" element={fullAccessOnly(<AppUpdateApps />)} />
          <Route path="app-update/:packageName" element={fullAccessOnly(<AppUpdateOverview />)} />
          <Route
            path="app-update/:packageName/channels"
            element={fullAccessOnly(<AppUpdateChannelMgr />)}
          />
          <Route
            path="app-update/:packageName/devices"
            element={fullAccessOnly(<AppUpdateDeviceIdMgr />)}
          />
          <Route
            path="app-update/:packageName/statistics"
            element={fullAccessOnly(<AppVersionStatistics />)}
          />
          <Route path="hub-ota" element={fullAccessOnly(<HubOtaManagement />)} />
          <Route path="imu-ota" element={fullAccessOnly(<ImuOtaManagement />)} />
          <Route path="gnss-ota" element={fullAccessOnly(<GnssOtaManagement />)} />
          <Route path="imu-production" element={fullAccessOnly(<ImuProduction />)} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="account" element={<Account />} />
          <Route
            path="user-management"
            element={
              <RequireRoles roles={['admin']}>
                <UserManagement />
              </RequireRoles>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
